import React, { useEffect, useState } from 'react';
import { useOrderContext } from '../context/OrderContext';

import './ProductVariant.scss';

const ProductVariant = ({ variant = {} }) => {
    const { quantities, setQuantity } = useOrderContext();
    const currentValue = quantities[variant.SKU] ?? '0';

    const [hasInputFocus, setInputFocus] = useState(false);

    return (
        <div className="product-variant__wrapper">
            <div className={"product-variant " + (quantities[variant.SKU] > 0 ? 'product-variant--active' : '')}>
                {variant.variant && <div className="product-variant--name">{variant.variant}</div>}
                <img className="product-variant--picture" src={variant.picture} alt={variant.sku} />
                <br />
                <div className="product-variant--sku">SKU: {variant.SKU}</div>
                <div className="product-variant--price">
                    {variant.price}€
                    / {variant.wholesalePrice}€
                </div>
                <div className="product-variant--quantity">
                    <div className="input-group input-group-sm">
                        <button onClick={e => setQuantity(variant.SKU, currentValue - 1)} className="btn btn-light">-</button>
                        <input
                            value={hasInputFocus && currentValue == '0' ? '' : currentValue}
                            onChange={(e) => setQuantity(variant.SKU, e.target.value)}
                            onFocus={() => setInputFocus(true)}
                            onBlur={() => setInputFocus(false)}
                            className="form-control text-center" type="number" name={variant.SKU} />
                        <button onClick={e => setQuantity(variant.SKU, currentValue + 1)} className="btn btn-light">+</button>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default ProductVariant